import { Routes } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { FreeTrialGuard } from './guards/free-trial.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'admin'
  },
  {
    path: 'free-trial',
    component: AuthCallbackComponent,
    canActivate: [FreeTrialGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin-routing.module').then(m => m.adminRoutes)
  },
  {
    path: '**',
    redirectTo: 'admin/b2b/profile',
    pathMatch: 'full'
  }
];
